<template>
  <span>
    <!-- <VueApexCharts type="line" height="400" :options="chartOptions" :series="series"></VueApexCharts> -->
    <VueApexCharts type="bar" height="400" :options="chartOptions" :series="series"></VueApexCharts>
  </span>
</template>
  
<script>
// Bar chart for "Active Users" card.
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    VueApexCharts,
  },
  props: {
    barChartData: {
      type: Object, default: {
        labels: [],
        datasets: [],
      }
    },
    title: { type: String, default: "Title" },
    isLoaded: { type: Boolean, default: false }
  },
  data() {
    return {

      series: [{
        name: 'Employed',
        data: [672, 706, 600]
      }, {
        name: 'Employed and currently pursuing a higher degree',
        data: [459, 521, 429]
      }, {
        name: 'Pursuing a higher degree',
        data: [213, 185, 214]
      },
      {
        name: 'Unemployed',
        data: [211, 185, 171]}
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 450
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        colors:['#6631D5', '#4D63E0', '#3404EA', '#1BC6F5'],
        dataLabels: {
          enabled: true
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: ['2020', '2021', '2022'],
        },
        yaxis: {
          title: {
            text: 'Number of alumni'
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            }
          }
        }
      },

    };
  },
  methods: {
  },
};
</script>